import { mdiMenuDown, mdiMenuUp } from '@mdi/js'
import Icon from '@mdi/react'
import { useAtom } from 'jotai'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import { Tag } from '@/components/ui/tag'
import { Text } from '@/components/ui/typography'
import { selectedLanguagesAtom, showOptionsAtom, toggleSelectedLanguages } from '@/store/translate'

const SelectedOptions = () => {
    const { t } = useTranslation()
    const [selectedLangs] = useAtom(selectedLanguagesAtom)
    const [showOptions, toggleOptions] = useAtom(showOptionsAtom)
    return (
        <Flex
            border="1px solid rgb(216, 215, 213)"
            _dark={{ borderColor: 'rgba(84, 79, 64, 0.4)' }}
            borderRadius="4px"
            p="4px"
            minH="44px"
            alignItems="center"
        >
            <Flex onClick={() => toggleOptions(!showOptions)} justifyContent="space-between" alignItems="top" flexGrow="1" cursor="pointer">
                <Box>
                    {selectedLangs.length === 0 && (
                        <Flex alignItems="center" minH="28px" my="4px">
                            <Text pl="12px" color="secondary.850">
                                {t('translate.multiSelect.selectLangs')}
                            </Text>
                        </Flex>
                    )}
                    {selectedLangs.length > 0 &&
                        selectedLangs.map((lang) => (
                            <Tag
                                key={lang.languageCode}
                                variant="multi-select"
                                m="4px"
                                onClose={(e) => {
                                    e.stopPropagation()
                                    toggleSelectedLanguages(lang)
                                }}
                            >
                                {lang.languageEnglishName}
                            </Tag>
                        ))}
                </Box>

                <Box cursor="pointer" mr="4px" mt="4px">
                    <Icon size={1} path={showOptions ? mdiMenuUp : mdiMenuDown} />
                </Box>
            </Flex>
        </Flex>
    )
}

export default SelectedOptions
